export enum RoundupBlockType {
  PropertyMarkets,
  MarketNews,
  OtherBusiness,
  Macronews,
  Earnings,
}
